// extracted by mini-css-extract-plugin
module.exports = {"share":"Share_share__1lmks","share__icon":"Share_share__icon__1VAa3"};